module.exports = __webpack_public_path__ + "static/img/applykong.fc0d6a53.png";